import React, { useEffect, useState, Fragment } from "react";
import WspolnotyLokaleLista from "./WspolnotyLokaleLista";
import WspolnotyLokaleDodaj from "./WspolnotyLokaleDodaj";


const WspolnotyLokale = props => {

    const { wspolnota, wybranaUlica, lokale } = props;

    const [lokaleUlica, setLokaleUlica] = useState([]);

    const [activeWindow, setActiveWindow] = useState("lista");

    useEffect( () => {
        setLokaleUlica( lokale?.filter( l => l?.ulica == wybranaUlica) )
    },[wybranaUlica, lokale])

    const page = () => {
        switch(activeWindow) {
            case "lista":
                return (   
                    <WspolnotyLokaleLista 
                        lokaleUlica={lokaleUlica}
                        setActiveWindow={setActiveWindow}
                        wspolnota={wspolnota}
                    /> );
            case "dodaj":
                return (
                    <WspolnotyLokaleDodaj
                        idw={wspolnota?.id}
                        setActiveWindow={setActiveWindow}
                        wybranaUlica={wybranaUlica}
                    />
                );
            default: return (<Fragment></Fragment>);
        }
    }

    return (
        <div className="wspolnotyLokale ramka">
            {page()}
        </div>
    )
}

export default WspolnotyLokale;